import TopMenu from '../components/TopMenu';
import BottomMenu from '../components/BottomMenu';
import { Row, Col, Container, Image } from 'react-bootstrap';

import Accuride from '../images/accuride.jpg';
import Alcoa from '../images/alcoa.jpg';
import Arvinmeritor from '../images/arvinmeritor.jpg';
import Bendix from '../images/bendix.jpg';
import Bostrom from '../images/bostrom.jpg';
import Cummins from '../images/cummins.jpg';

import Dana from '../images/dana.jpg';
import Delcoremy from '../images/delcoremy.jpg';
import Dynacraft from '../images/dynacraft.jpg';
import Eaton from '../images/eaton.jpg';
import Fleetguard from '../images/fleetguard.jpg';
import Gunite from '../images/gunite.jpg';

import Haldex from '../images/haldex.jpg';
import Leeceneville from '../images/leeceneville.jpg';
import Panapacific from '../images/panapacific.jpg';
import Peterbiltbrand from '../images/peterbiltbrand.jpg';
import Roadranger from '../images/roadranger.jpg';
import skf from '../images/skf.jpg';

function Parts() {
    return (
        <div>
            <TopMenu />

            <Container>
                <h2 className='htitleb text-center'>Parts</h2>
                <p>HT&T Parts Department maintains one of the largest and most complete heavy- and medium-duty parts departments in Hawaii.
                    We stock genuine Peterbilt, Isuzu, and McNeilus parts and accessories. Our extensive parts
                    inventory ensures we’ll have what you need in stock to get you up and running as quickly as possible.
                    In the event that a special order is required, our factory-trained parts staff will locate the part on
                    the mainland and get it delivered to you as soon as possible. To ensure that we provide you with the
                    best and most informed service, our parts staff are constantly undergoing training to keep updated
                    on the latest products and technologies in the industry. Come visit us and experience the difference! </p>
                <br />
                <h4 className='htitleb text-center'>Parts Department</h4>
                <Row className='justify-content-center'>
                    <Col md={6}>
                        <Row className='justify-content-center'>
                            <Col md={3}>
                                <h5 className='titleb text-center'>Hours</h5>
                                <p className='text-center'>Monday - Friday (Closed Weekend) <br /> 7:00 AM - 4:00 PM</p>

                            </Col>
                            <Col md={3}>
                                <h4 className='titleb text-center'>Contact</h4>
                                <p className='text-center'> (808) 532-7502<br /> (Honolulu Office)</p>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={4}>
                        <Image
                            src={Dana}
                        />

                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col md={2}>
                        <a href="https://www.accuridecorp.com/">
                            <div id="blackbox">
                                <Image
                                    src={Accuride}
                                />
                            </div>
                        </a>
                    </Col>
                    <Col md={2}>
                        <a href="https://www.alcoa.com">
                            <div id="blackbox">
                                <Image
                                    src={Alcoa}
                                />
                            </div>
                        </a>
                    </Col>
                    <Col md={2}>
                        <a href="https://www.meritorpartsxpress.com">
                            <div id="blackbox">
                                <Image
                                    src={Arvinmeritor}
                                />
                            </div>
                        </a>
                    </Col>
                    <Col md={2}>
                        <a href="https://www.bendix.com/en/">
                            <div id="blackbox">
                                <Image
                                    src={Bendix}
                                />
                            </div>
                        </a>
                    </Col>
                    <Col md={2}>
                        <a href="https://bostromseating.com/">
                            <div id="blackbox">
                                <Image
                                    src={Bostrom}
                                />
                            </div>
                        </a>
                    </Col>
                    <Col md={2}>
                        <a href="https://www.cummins.com">
                            <div id="blackbox">
                                <Image
                                    src={Cummins}
                                />
                            </div>
                        </a>
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col md={2}>
                        <a href="https://www.dana.com/">
                            <div id="blackbox">
                                <Image
                                    src={Dana}
                                />
                            </div>
                        </a>
                    </Col>
                    <Col md={2}>
                        <a href="https://www.delcoremy.com/">
                            <div id="blackbox">
                                <Image
                                    src={Delcoremy}
                                />
                            </div>
                        </a>
                    </Col>
                    <Col md={2}>
                        <a href="https://www.dynacraftnet.com/">
                            <div id="blackbox">
                                <Image
                                    src={Dynacraft}
                                />
                            </div>
                        </a>
                    </Col>
                    <Col md={2}>
                        <a href="https://www.eaton.com/country.html">
                            <div id="blackbox">
                                <Image
                                    src={Eaton}
                                />
                            </div>
                        </a>
                    </Col>
                    <Col md={2}>
                        <a href="https://www.fleetguard.com">
                            <div id="blackbox">
                                <Image
                                    src={Fleetguard}
                                />
                            </div>
                        </a>
                    </Col>
                    <Col md={2}>
                        <a href="https://www.rockfordbrake.com/">
                            <div id="blackbox">
                                <Image
                                    src={Gunite}
                                />
                            </div>
                        </a>
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col md={2}>
                        <a href="https://www.haldex.com/">
                            <div id="blackbox">
                                <Image
                                    src={Haldex}
                                />
                            </div>
                        </a>
                    </Col>
                    <Col md={2}>
                        <a href="https://www.prestolite.com/">
                            <div id="blackbox">
                                <Image
                                    src={Leeceneville}
                                />
                            </div>
                        </a>
                    </Col>
                    <Col md={2}>
                        <a href="https://www.panapacific.com/">
                            <div id="blackbox">
                                <Image
                                    src={Panapacific}
                                />
                            </div>
                        </a>
                    </Col>
                    <Col md={2}>
                        <a href="https://www.peterbilt.com/">
                            <div id="blackbox">
                                <Image
                                    src={Peterbiltbrand}
                                />
                            </div>
                        </a>
                    </Col>
                    <Col md={2}>
                        <a href="https://www.eaton.com/us/en-us/markets/vehicles/roadranger.html">
                            <div id="blackbox">
                                <Image
                                    src={Roadranger}
                                />
                            </div>
                        </a>
                    </Col>
                    <Col md={2}>
                        <a href="https://www.skf.com/">
                            <div id="blackbox">
                                <Image
                                    src={skf}
                                />
                            </div>
                        </a>
                    </Col>
                </Row>
                <br />
            </Container>
            <BottomMenu />
        </div>
    );
}

export default Parts;

/*
 <p>HT&T Parts Department maintains one of the largest and most complete heavy- and medium-duty parts departments in Hawaii. 
                            We stock genuine Peterbilt, Isuzu, Autocar and McNeilus parts and accessories. Our extensive parts 
                            inventory ensures we’ll have what you need in stock to get you up and running as quickly as possible. 
                            In the event that a special order is required, our factory-trained parts staff will locate the part on
                             the mainland and get it delivered to you as soon as possible. To ensure that we provide you with the
                              best and most informed service, our parts staff are constantly undergoing training to keep updated 
                              on the latest products and technologies in the industry. Come visit us and experience the difference! </p>
*/